import HttpRequest from '@/libs/api.axios'
import globConfig from '@/config/config';

// const baseUrl = process.env.NODE_ENV === 'development' ? globConfig.apiUrl.dev : globConfig.apiUrl.pro
const baseUrl = globConfig.apiUrl.dev;
// const baseUrl = globConfig.apiUrl.pro;
const axios = new HttpRequest(baseUrl);
export default axios


// WEBPACK FOOTER //
// ./src/libs/api.request.js